var _defs, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrentActions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 149.69 149.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#11ccea;stroke-miterlimit:10;stroke-width:10px;}.cls-2{fill:#11ccea;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 74.85,
    cy: 74.85,
    r: 69.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.84,355.08l-5.73,5.58c-2.74-1.13-5.41-2.64-8.29-3.33-9.23-2.25-17.23.27-23.36,7.49S206,380.63,210,389.39c3.85,8.55,10.78,13.29,20.22,13.7a23.22,23.22,0,0,0,22.71-31.57,1.59,1.59,0,0,1,.4-2c1.79-1.73,3.49-3.55,5.26-5.38,7,11.3,6.16,29.5-7.67,40.57a31.72,31.72,0,1,1-.06-49.61Z",
    transform: "translate(-157.77 -304.1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.06,389,215.4,373.32l5.92-5.85,9.6,9.87c11.41-11.43,22.6-22.66,33.74-33.83l5.89,5.95Z",
    transform: "translate(-157.77 -304.1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentActions);
export default __webpack_public_path__ + "static/media/current_actions.8abcd82c5961c027aa62e632bf809304.svg";
export { ForwardRef as ReactComponent };